import React, { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Lottie from 'react-lottie'
import moment from "moment";
import { sendNotificationTripConfirmed } from "../../../utils/functions/notification";
import releaseRidersFromBidLock from "../../../utils/functions/riders";
import RiderServices from "../../../services/externalServices/riders/RiderServices";
import TripServices from "../../../services/externalServices/trip/TripServices";
// import tripCompletedAnimation from '../../assets/lottie/'

import { lottieAnimations } from "../../../utils/functions/lottieAnimations";

const PaymentSuccess = ({ packageName, selectedDate, selectedTime, rider, handleSendMessage, tripId }) => {
    const navigate = useNavigate();

    const tripDateFormatted = selectedDate ? moment(selectedDate).format("DD MMM, YYYY") : "";
    const tripTimeFormatted = selectedTime ? moment(selectedTime).format("hh:mm A") : "";

    const handleClose = () => {
        navigate("/", { replace: true });
    };

    useEffect(() => {
        notifyPartner();
    }, []);

    const notifyPartner = async () => {
        const fcm_tokens = [rider?.fcm_token];
        const phone_number = [rider?.phone_number];

        await sendNotificationTripConfirmed({
            fcmTokens: fcm_tokens,
            phoneNumbers: phone_number,
            packageName,
            selectedDate,
            selectedTime,
        });

        const updatedTripData = await TripServices.update(tripId, { status: "BOOKED" });
        if (updatedTripData) {
            console.log("Updated trip status to BOOKED. Trip id:", tripId);
        }

        const newBooking = { packageName, selectedDate, selectedTime, tripId, tripThumbnail: "", internalComments: "" };

        await RiderServices.updateRiderAddBookedDate({ phone_number, newBooking })
            .then(response => {
                if (response.success) {
                    console.log("Booking details updated successfully!");
                } else {
                    console.error("Error", response.message);
                }
            })
            .catch(err => console.error("Something went wrong.", err));

        await releaseRidersFromBidLock([rider?.phone_number]);
    };

    return (
        <div className="flex flex-col items-center justify-center h-screen p-4">
            <div className="flex flex-col items-center">
                {/* <Lottie animationData={lottieAnimations.tripCompleted} className="w-40 h-40" /> */}
                <h1 className="text-xl font-semibold mt-4">Congratulations!</h1>
                <p className="text-gray-600">Your {packageName || "tour package"} is booked and scheduled.</p>
            </div>

            <div className="mt-6 p-4 border rounded-lg flex flex-col md:flex-row justify-between items-center w-full max-w-md">
                <div className="text-center">
                    <p className="text-sm text-gray-500">Scheduled for</p>
                    <p className="font-semibold">{tripDateFormatted}</p>
                </div>
                <div className="w-1 h-8 bg-gray-400 mx-4"></div>
                <div className="text-center">
                    <p className="text-sm text-gray-500">Pickup at</p>
                    <p className="font-semibold">{tripTimeFormatted}</p>
                </div>
            </div>

            <p className="text-gray-500 mt-4">An exciting journey awaits you!</p>
            <p className="text-gray-500 mt-2">See history at "Home - Menu - Ride History"</p>

            <button
                className="mt-6 bg-blue-500 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-600"
                onClick={handleClose}
            >
                Close
            </button>
        </div>
    );
};

export default PaymentSuccess;
